import React, { useContext } from "react";
import { FaTruckLoading, FaBoxes, FaBatteryFull, FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css";
import BannerImage from "./mhe.jpg";

const MHE: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/mhe-safety');
    } else {
      navigate('/login', { state: { from: '/booking/mhe-safety' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Material Handling</span>
          <h1 className="hero-title">MHE & Forklift Safety</h1>
          <p className="hero-subtitle">
            Forklifts are powerful machines, not toys. Stability triangles, load centers,
            and operational best practices.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">The Stability Triangle</h2>
              <p className="article-text">
                Forklifts operate on a 3-point suspension system (front wheels and rear pivot).
                If the Center of Gravity (CoG) moves outside this triangle, the forklift tips over.
                <br /><strong>Causes of Tipping:</strong> Overloading, turning too fast, driving with load raised,
                or driving across slopes.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Safe Operation</h2>
              <p className="article-text">
                <ul style={{ paddingLeft: '20px', color: '#ccc', lineHeight: '1.8' }}>
                  <li><strong>Travel Low:</strong> Keep forks 4-6 inches off the ground.</li>
                  <li><strong>Look Back:</strong> Always look behind before reversing.</li>
                  <li><strong>Pedestrians:</strong> Eye contact is mandatory. Honk at corners.</li>
                  <li><strong>Parking:</strong> Forks down, neutral gear, handbrake on, engine off.</li>
                </ul>
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Battery/Fuel Safety</h2>
              <p className="article-text">
                Recharging or refueling areas have specific hazards. Lead-acid batteries produce explosive hydrogen gas.
                LPG cylinders can cause cold burns. Always wear face shields and aprons when maintaining power sources.
                Ensure eyewash stations are nearby.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Do's and Don'ts</h4>
              <ul className="key-list">
                <li><FaTruckLoading className="check-icon" /> Secure Your Load</li>
                <li><FaBoxes className="check-icon" /> Watch Overhead Clearance</li>
                <li><FaBatteryFull className="check-icon" /> Charge in Ventilated Areas</li>
                <li><FaEye className="check-icon" /> Watch Blind Spots</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Operate Safely</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Only trained and authorized personnel may operate MHE.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default MHE;
